import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { Rule } from '../models/rule';
import { AppCookieService } from '@ace/ace';

@Injectable()
export class CommonRestService {

  exceptionDetailData = new ExceptionDetailData();

  private messageSource = new BehaviorSubject(this.exceptionDetailData);

  constructor(private http: HttpClient, private cookieService: AppCookieService) { }

  commonGet(url, param?): any {
    return this.http.get(url, { params: param });
  }

  commonGetWithPathVariable(url, singleVarialble): any {
    return this.http.get(url + singleVarialble);
  }

  commonGetWithPathVariables(url, varialble1, variable2): any {
    return this.http.get(url + varialble1 + "/" + variable2);
  }

  public getTotalCount(url, clientId: number, rules: Rule[]): any {
    return this.http.post(url + '/' + clientId, rules);
  }

  public commonPost(url: string, obj: any, param?: { [key: string]: any }): Observable<any> {
    return this.http.post<any>(url, obj, { params: param });
  }

  public commonPostWithReqBody(url, obj): any {
    return this.http.post(url, obj);
  }

  public commonPostWitPathVariable(url, obj, param?): any {
    return this.http.post<any>(url, obj, { params: param });
  }

  commonDelete(url, param): any {
    return this.http.delete(url, { params: param });
  }

  commonGetEnumList(url): any {
    return this.http.get(url);
  }

  postOpenNewTab(obj, url) {
    const mapForm = document.createElement("form");
    const token = this.cookieService.getCookie("VISION-XSRF-TOKEN");

    mapForm.setAttribute("target", "_blank");
    mapForm.method = "POST";
    mapForm.action = url;
    Object.keys(obj).forEach(function (param) {
      const mapInput = document.createElement("input");
      mapInput.type = "hidden";
      mapInput.name = param;
      mapInput.setAttribute("value", obj[param]);
      mapForm.appendChild(mapInput);
    });

    const mapCSRFInput = document.createElement("input");
    mapCSRFInput.type = "hidden";
    mapCSRFInput.name = "_csrf";
    mapCSRFInput.value = token;
    mapForm.appendChild(mapCSRFInput);
    document.body.appendChild(mapForm);
    mapForm.submit();
  }

  changeMessage(message: ExceptionDetailData) {
    this.messageSource.next(message);
  }

  public userListAsExcelDownload(url: string, downloadColumns, rules) {
    const downloadVo = new DownloadListVo();
    downloadVo.columnList = downloadColumns;
    downloadVo.filterVos = rules;
    return this.http.post(url, downloadVo, { responseType: 'blob' });
  }

}

export class ExceptionDetailData {
  clientName: string;
  carrierName: string;
  fileType: string;
  tabType: string;
  errorMesg: string;
}
export class DownloadListVo {
  columnList: string[];
  filterVos: any;
}
